interface Props {
  className?: string;
  tags: Array<string>;
}

function CruisesUrgencyTags(_props: Props) {
  return null
}

export default CruisesUrgencyTags
